import { createSlice } from '@reduxjs/toolkit';

export const FamilyCompensationSlice = createSlice({
  name: 'familyCompensation',
  initialState: {
    family_compensation_list: [],
    family_compensation_list_select: [],
  },
  reducers: {
    setFamilyCompensationRedux: (state, { payload }) => {
      state.family_compensation_list = payload;
    },
    setCajaCompensacionSelectRedux: (state, { payload }) => {
      state.family_compensation_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFamilyCompensationRedux, setCajaCompensacionSelectRedux } =
  FamilyCompensationSlice.actions;
